"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isNull2 = _interopRequireDefault(require("lodash/isNull"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactPortal = require("react-portal");

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ModalWrap =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ModalWrap, _React$Component);

  function ModalWrap(props) {
    var _this;

    _classCallCheck(this, ModalWrap);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ModalWrap).call(this, props));

    _this.handleAnimationStateChange = function (e) {
      var type = e.type;
      var isAnimationRunning = type !== 'animationend';

      _this.setState({
        isAnimationRunning: isAnimationRunning
      });
    };

    _this.state = {
      animation: '',
      isAnimationRunning: false,
      visible: null
    };
    return _this;
  }
  /**
   * Make sure not to completely hide modal until animations are finished.
   * @param {object} props - new props
   * @param {object} state - current state
   * @returns {object} or {null} if no update is needed
   */


  _createClass(ModalWrap, [{
    key: "componentDidUpdate",

    /**
     * Need to do a 'pre-render' check update for components that rely on DOM measurements when they
     * are updating. Otherwise, the animation will kill their logic.
     * @param {object} prevProps - previous props
     * @param {object} prevState - previous state
     */
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.visible !== this.state.visible) {
        // Disabling old rule based on React 15 : react/no-did-update-set-state
        // https://github.com/airbnb/javascript/issues/1875

        /* eslint-disable */
        this.setState({
          animation: this.getAnimation(this.props.visible)
        });
        /* eslint-enable */
      }
    }
    /**
     * Gets a different animation depending on visible value.
     * @param {boolean} visible - visibility state of modal
     * @returns {string} name of animation
     */

  }, {
    key: "getAnimation",
    value: function getAnimation(visible) {
      var animation;

      if (visible) {
        animation = 'fade-in';
      } else {
        animation = 'fade-out';
      }

      return animation;
    }
    /**
     * Callback handler when animation start or stop. Updates the state accordingly.
     * @param {event} e - synthetic event
     */

  }, {
    key: "isModalVisible",

    /**
     * Compares animation to visible state to determine if modal should be visible
     * @param {boolean} visible - visibility of modal
     * @param {boolean} isAnimationRunning - animation state of modal
     * @returns {boolean} true if modal is visible
     */
    value: function isModalVisible(visible, isAnimationRunning) {
      return visible || isAnimationRunning;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          type = _this$props.type,
          visible = _this$props.visible,
          props = _objectWithoutProperties(_this$props, ["className", "type", "visible"]);

      var _this$state = this.state,
          animation = _this$state.animation,
          isAnimationRunning = _this$state.isAnimationRunning; // Do not render Modal into DOM until visibility is true

      if ((0, _isNull2.default)(this.state.visible)) {
        return null;
      }

      return _react.default.createElement(_reactPortal.Portal, null, _react.default.createElement("div", _extends({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-modal ").concat(_ThemeManager.default.getVar('classPrefix'))),
        "data-animation": animation,
        "data-appearance": "overlay",
        "data-hidden": !this.isModalVisible(visible, isAnimationRunning),
        "data-type": type,
        onAnimationStart: this.handleAnimationStateChange,
        onAnimationEnd: this.handleAnimationStateChange
      }, props)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // Only set state and render after first visible occurrence, conditions to pass are:
      // 1) State visible is not set but prop is visible, and there is a prop change.
      // 2) Visible state has been set, and there is a prop change.
      if (props.visible && (0, _isNull2.default)(state.visible) && props.visible !== state.visible || !(0, _isNull2.default)(state.visible) && props.visible !== state.visible) {
        return _objectSpread({}, state, {
          isAnimationRunning: true,
          visible: props.visible
        });
      }

      return null;
    }
  }]);

  return ModalWrap;
}(_react.default.Component);

exports.default = ModalWrap;
ModalWrap.TYPE = {
  CONFIRM: 'confirm',
  DEFAULT: 'default',
  FULL_PAGE: 'full-page'
};
ModalWrap.defaultProps = {
  type: ModalWrap.TYPE.DEFAULT
};
ModalWrap.propTypes = {
  /**
   * Content to be displayed in modal wrapper e.g. Modal, ConfirmModal.
   */
  children: _propTypes.default.node,

  /**
   * Customize additional class name.
   */
  className: _propTypes.default.string,

  /**
   * Type of modal the wrap should expect.
   */
  type: _propTypes.default.oneOf([ModalWrap.TYPE.CONFIRM, ModalWrap.TYPE.DEFAULT, ModalWrap.TYPE.FULL_PAGE]),

  /**
   * Visible will to determine whether the modal wrapper is visible or not.
   */
  visible: _propTypes.default.bool
};